// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-banner {
  height: 100%;
  width: 100%;
}

.login-banner-carousel-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
}

.login-banner-carousel-slide {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.45s ease-in-out;
}

.login-banner-slide {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}

.login-banner-image {
  width: 100%;
  object-fit: cover;
}

.login-banner-text-wrapper {
  width: 90%;
  position: absolute;
  color: white;
  padding: 0px 25px 0px 40px;
  z-index: 1;
}

.login-banner-text-wrapper--bottom {
  bottom: 35%;
}

.login-banner-title {
  letter-spacing: 4px;
  font-weight: bold;
  line-height: normal;
  font-family: "Open Sans", Arial, sans-serif;
  cursor: default;
}

.login-banner-title--medium {
  font-size: 2.3em;
}

.login-banner-description {
  font-size: 1.3em;
  line-height: normal;
  letter-spacing: 1px;
  margin-top: 20px;
  font-family: "Open Sans", Arial, sans-serif;
  cursor: default;
}

.login-banner-dots {
  justify-content: flex-end;
  display: flex;
  position: relative;
  bottom: 25px;
  right: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/LoginBanner.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".login-banner {\n  height: 100%;\n  width: 100%;\n}\n\n.login-banner-carousel-container {\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.login-banner-carousel-slide {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.45s ease-in-out;\n}\n\n.login-banner-slide {\n  width: 100%;\n  height: 100%;\n  flex-shrink: 0;\n}\n\n.login-banner-image {\n  width: 100%;\n  object-fit: cover;\n}\n\n.login-banner-text-wrapper {\n  width: 90%;\n  position: absolute;\n  color: white;\n  padding: 0px 25px 0px 40px;\n  z-index: 1;\n}\n\n.login-banner-text-wrapper--bottom {\n  bottom: 35%;\n}\n\n.login-banner-title {\n  letter-spacing: 4px;\n  font-weight: bold;\n  line-height: normal;\n  font-family: \"Open Sans\", Arial, sans-serif;\n  cursor: default;\n}\n\n.login-banner-title--medium {\n  font-size: 2.3em;\n}\n\n.login-banner-description {\n  font-size: 1.3em;\n  line-height: normal;\n  letter-spacing: 1px;\n  margin-top: 20px;\n  font-family: \"Open Sans\", Arial, sans-serif;\n  cursor: default;\n}\n\n.login-banner-dots {\n  justify-content: flex-end;\n  display: flex;\n  position: relative;\n  bottom: 25px;\n  right: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
